export default __webpack_public_path__ + "static/media/18.6c576db8.jpg";